/**
 * Polyfill for Nodelist
 * from https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
 */
if (window.NodeList && !NodeList.prototype.forEach) {
    (NodeList.prototype as any).forEach = Array.prototype.forEach;
}
